import React, { useEffect, useState } from 'react';

import Layout from '@components/layout';
import SEO from '@components/seo';

import styles from './diet-tracker.module.scss';

const APP_BASE_URL = 'vitltracker://vitl.com/app/diet-tracker';
const AUTO_OPEN_DELAY_MS = 150;
const DESKTOP_OVERRIDE_PARAM = 'showOnDesktop';

const isIosDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = window.navigator.userAgent || '';
  const platform = window.navigator.platform || '';
  const touchPoints = window.navigator.maxTouchPoints || 0;

  return /iPhone|iPad|iPod/i.test(userAgent)
    || /iPhone|iPad|iPod/i.test(platform)
    || (platform === 'MacIntel' && touchPoints > 1);
};

const buildUrl = (baseUrl: string, search: string): string => {
  if (!search) {
    return baseUrl;
  }

  return `${baseUrl}${search}`;
};

const DietTrackerLauncherPage: React.FC = () => {
  const [appUrl, setAppUrl] = useState(APP_BASE_URL);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    const { search } = window.location;
    const searchParams = new URLSearchParams(search);
    const showOnDesktop = searchParams.get(DESKTOP_OVERRIDE_PARAM) === 'true';
    const nextAppUrl = buildUrl(APP_BASE_URL, search);
    const nextIsIos = showOnDesktop || isIosDevice();

    setAppUrl(nextAppUrl);
    setIsIos(nextIsIos);

    if (!nextIsIos) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      window.location.assign(nextAppUrl);
    }, AUTO_OPEN_DELAY_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <Layout showHeader={false} showFooter={false}>
      <SEO
        noindex
        title="Open Diet Tracker"
        description="Open Diet Tracker in the app."
      />

      <section className={styles.wrapper}>
        <div className={styles.card}>
          <img className={styles.trackerLogo} src="/images/tracker/vitl-tracker-logo-hero.png" alt="Vitl Tracker" />
          {isIos ? (
            <>
              <h1 className={styles.title}>Log into the app</h1>
              <p className={styles.description}>
                We are opening Diet Tracker for you now. If nothing happens, use the button below.
              </p>

              <div className={styles.actions}>
                <a className={styles.buttonPrimary} href={appUrl}>
                  Log into app
                </a>
              </div>

              <p className={styles.hint}>
                If the app does not open automatically, return to this page and tap <strong>Log into app</strong>.
              </p>
            </>
          ) : (
            <>
              <h1 className={styles.title}>Open this on your iPhone</h1>
              <p className={styles.description}>
                This login link only works in the Diet Tracker iPhone app. Reopen the email on your iPhone and try again there.
              </p>
            </>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default DietTrackerLauncherPage;
